import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./Date.css";
import {
  addFilters,
  // applyFilters,
} from "../../store/slices/FilterSliceSalesSuccessCenter";
import ViMultiSelect from "../Multi-Select-Dropdown/ViMultiSelectDropdownSalesSuccess";
import { useQuery } from "@tanstack/react-query";
import {
  fetchRegion,
  fetchNewRegion,
  fetchStates,
  fetchArea,
  fetchDealer,
  fetchDealercode,
  fetchProductLine,
  fetchLOB,
  fetchTsm,
  fetchSpm,
  // reducer,
} from "./apiSalesSucessCenter";

//*------------------COMP----------------------*//
export default function SalesSuccessFilter() {
  const { data, submitted } = useSelector(
    (state) => state.filtersSalesSuccessCenter
  );

  // const { data: newdata } = useSelector((state) => state.forms);

  const {
    region: pRegion,
    NEW_REGION: pNewRegion,
    state: pState,
    state_office: pArea,
    dealer_name: pDealer,
    dealer_code: pDealerCode,
    Product_Line: pProductLine,
    lob: pLob,
    Tsm_Name: pTsmName,
    Spm_Name: pSpmName,
  } = data;

  const dispatch = useDispatch();
  const [clicked, setClicked] = useState(1);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedNewRegion, setSelectedNewRegion] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState([]);
  const [selectedDealerCode, setSelectedDealerCode] = useState([]);
  const [selectedProductLine, setSelectedProductLine] = useState([]);
  const [selectedLob, setSelectedLOB] = useState([]);
  const [selectedTsm, setSelectedTsm] = useState([]);
  const [selectedSpm, setSelectedSpm] = useState([]);

  //* ---------------USE QUERY---------------------/

  const { data: regions, isLoading: rL } = useQuery({
    queryKey: ["region", submitted],
    queryFn: () => fetchRegion(),
    initialData: [],
  });

  const { data: Newregions, isLoading: nrL } = useQuery({
    queryKey: ["Newregion", submitted, pRegion],
    queryFn: () => fetchNewRegion(pRegion),
    initialData: [],
  });

  const { data: states, isLoading: sL } = useQuery({
    queryKey: ["states", submitted, pRegion, pNewRegion],
    queryFn: () => fetchStates(pRegion, pNewRegion),
    initialData: [],
  });

  const { data: area, isLoading: soL } = useQuery({
    queryKey: ["area", submitted, pRegion, pNewRegion, pState],
    queryFn: () => fetchArea(pRegion, pNewRegion, pState),
    initialData: [],
  });

  const { data: dealer, isLoading: dL } = useQuery({
    queryKey: ["dealer", submitted, pRegion, pNewRegion, pState, pArea],
    queryFn: () => fetchDealer(pRegion, pNewRegion, pState, pArea),
    initialData: [],
  });

  const { data: dealercode, isLoading: dcL } = useQuery({
    queryKey: [
      "dealercode",
      submitted,
      pRegion,
      pNewRegion,
      pState,
      pArea,
      pDealer,
    ],
    queryFn: () => fetchDealercode(pRegion, pNewRegion, pState, pArea, pDealer),
    initialData: [],
  });

  const { data: productLine, isLoading: plL } = useQuery({
    queryKey: [
      "productLine",
      submitted,
      pRegion,
      pNewRegion,
      pState,
      pArea,
      pDealer,
      pDealerCode,
    ],
    queryFn: () =>
      fetchProductLine(
        pRegion,
        pNewRegion,
        pState,
        pArea,
        pDealer,
        pDealerCode
      ),
    initialData: [],
  });

  const { data: lob, isLoading: lobL } = useQuery({
    queryKey: [
      "lob",
      submitted,
      pRegion,
      pNewRegion,
      pState,
      pArea,
      pDealer,
      pDealerCode,
      pProductLine,
    ],
    queryFn: () =>
      fetchLOB(
        pRegion,
        pNewRegion,
        pState,
        pArea,
        pDealer,
        pDealerCode,
        pProductLine
      ),
    initialData: [],
  });
  const { data: tsm, isLoading: tL } = useQuery({
    queryKey: [
      "tsm",
      submitted,
      pRegion,
      pNewRegion,
      pState,
      pArea,
      pDealer,
      pDealerCode,
      pProductLine,
      pLob,
    ],
    queryFn: () =>
      fetchTsm(
        pRegion,
        pNewRegion,
        pState,
        pArea,
        pDealer,
        pDealerCode,
        pProductLine,
        pLob
      ),
    initialData: [],
  });
  const { data: spm, isLoading: spmL } = useQuery({
    queryKey: [
      "spm",
      submitted,
      pRegion,
      pNewRegion,
      pState,
      pArea,
      pDealer,
      pDealerCode,
      pProductLine,
      pLob,
      pTsmName,
    ],
    queryFn: () =>
      fetchSpm(
        pRegion,
        pNewRegion,
        pState,
        pArea,
        pDealer,
        pDealerCode,
        pProductLine,
        pLob,
        pTsmName
      ),
    initialData: [],
  });

  //* ---------------HANDLE EVENTS---------------------/
  async function handleSearch() {
    let userSelectedFilter = {
      data: {
        region: pRegion || selectedRegion,
        New_Region: pNewRegion || selectedNewRegion,
        state: pState || selectedState,
        state_office: pArea || selectedArea,
        dealer_name: pDealer || selectedDealer,
        dealer_code: pDealerCode || selectedDealerCode,
        Product_Line: pProductLine || selectedProductLine,
        lob: pLob || selectedLob,
        Tsm_Name: pTsmName || selectedTsm,
        Spm_Name: pSpmName || selectedSpm,
      },
      submitted: clicked + 1,
    };

    dispatch(addFilters(userSelectedFilter));
    setClicked((prev) => prev + 1);
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  //*----------------------JSX-------------------------/
  return (
    <section className="">
      <div className="border-[#2c8a8b] border rounded-md  grid grid-cols-2 gap-2 p-2 md:gap-2 lg:grid-cols-[repeat(12,minmax(0,1fr))] md:grid-cols-4">
        <div className={divStyle}>
          <label className={labelStyle} htmlFor="region-select">
            Region
          </label>
          <ViMultiSelect
            id="region-select"
            options={regions}
            onSelectionChange={setSelectedRegion}
            opnsSelected={pRegion}
            keey="region"
            isLoading={rL}
          />
        </div>
        <div className={divStyle}>
          <label className={labelStyle} htmlFor="newregion-select">
            New Region
          </label>
          <ViMultiSelect
            id="newregion-select"
            options={Newregions}
            onSelectionChange={setSelectedNewRegion}
            opnsSelected={pNewRegion}
            keey="NEW_REGION"
            isLoading={nrL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle} htmlFor="state-select">
            State
          </label>
          <ViMultiSelect
            id="state-select"
            options={states}
            onSelectionChange={setSelectedState}
            opnsSelected={pState}
            keey="state"
            isLoading={sL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle} htmlFor="area-select">
            Area
          </label>
          <ViMultiSelect
            id="state-select"
            options={area}
            onSelectionChange={setSelectedArea}
            opnsSelected={pArea}
            keey="state_office"
            isLoading={soL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle} htmlFor="dealername-select">
            Dealer Name
          </label>
          <ViMultiSelect
            id="dealername-select"
            options={dealer}
            onSelectionChange={setSelectedDealer}
            opnsSelected={pDealer}
            keey="dealer_name"
            isLoading={dL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle} htmlFor="dealercode-select">
            Dealer Code
          </label>
          <ViMultiSelect
            id="dealercode-select"
            options={dealercode}
            onSelectionChange={setSelectedDealerCode}
            opnsSelected={pDealerCode}
            keey="dealer_code"
            isLoading={dcL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle} htmlFor="productline-select">
            Product Line
          </label>
          <ViMultiSelect
            id="productline-select"
            options={productLine}
            onSelectionChange={setSelectedProductLine}
            opnsSelected={pProductLine}
            keey="Product_Line"
            isLoading={plL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle} htmlFor="lob-select">
            LOB
          </label>
          <ViMultiSelect
            id="lob-select"
            options={lob}
            onSelectionChange={setSelectedLOB}
            opnsSelected={pLob}
            keey="lob"
            isLoading={lobL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle} htmlFor="tsm-select">
            TSM Name
          </label>
          <ViMultiSelect
            id="tsm-select"
            options={tsm}
            onSelectionChange={setSelectedTsm}
            opnsSelected={pTsmName}
            keey="Tsm_Name"
            isLoading={tL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle} htmlFor="spm-select">
            SPM Name
          </label>
          <ViMultiSelect
            id="spm-select"
            options={spm}
            onSelectionChange={setSelectedSpm}
            opnsSelected={pSpmName}
            keey="Spm_Name"
            isLoading={spmL}
          />
        </div>

        <div className="flex flex-col justify-end">
          <button
            className=" text-white w-full rounded-sm  bg-[#2A5775] "
            type="button"
            onClick={handleSearch}
          >
            Apply
          </button>
        </div>

        <div className="flex flex-col justify-end">
          <button
            className=" text-white bg-[#2A5775] rounded-sm w-full"
            onClick={handleRefresh}
          >
            Reset
          </button>
        </div>
      </div>
    </section>
  );
}

//*------------------CSS----------------------*//
const divStyle = "flex flex-col justify-center";
const labelStyle = "font-semibold py-1 text-xs text-[#2A5775]";
